import cn from 'classnames'
// import Icon from 'components/uiKit/Icon'
import type { ReactElement } from 'react'

import { testProps } from 'utils/test/qaData'

import * as s from './Tag.module.scss'

export interface ITagProps {
  bgColor?: string
  textColor?: string
  onClick?: () => void
  Icon?: ReactElement
  children: React.ReactNode
  name?: string
  border?: boolean
  value?: string
}

const Tag: React.FC<ITagProps> = ({ children, bgColor, textColor, onClick, Icon, name, value, border }) => {
  const onTagClick = () => {
    onClick?.()
  }

  const tagClasses = cn(s.root, { [s.color]: bgColor, [s.border]: border })
  return (
    <div
      className={tagClasses}
      onClick={onTagClick}
      style={{ background: bgColor, color: textColor }}
      {...testProps({ el: 'tag', name, value })}
    >
      {children}
      {Icon && <div className={s.icon}>{Icon}</div>}
    </div>
  )
}

export default Tag
